<template>
    <div>
        <h1 class="page_title">文件管理</h1>
        <div class="filter-container">
            <el-button size="small" class="filter-item" icon="el-icon-refresh" @click="getList"></el-button>
            <el-button size="small" class="filter-item" @click="showUploadDialog">上传文件</el-button>
        </div>
        <el-table :data="tableRecords" stripe>
            <el-table-column align="left" label="文件名" min-width="200">
                <template slot-scope="scope">
                    <a class="click_link" target="_blank" :href="scope.row.FileUrl">{{ scope.row.FileName }}</a>
                </template>
            </el-table-column>
            <el-table-column align="left" label="添加时间" width="150">
                <template slot-scope="scope">
                    <span>{{ scope.row.createdAt | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="文件大小" width="120">
                <template slot-scope="scope">
                    {{ $common.formatFileSize(scope.row.FileSize) }}
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" @click="toDelete(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="上传文件" :visible.sync="uploadDialog" width="450px">
            <el-form ref="uploadForm" :model="uploadForm" :rules="uploadFormRules" label-position="right"
                label-width="120px">
                <el-form-item class="form_item_val" label="文件名称" prop="name">
                    <el-input size="small" style="width: 200px;" v-model="uploadForm.name"></el-input>
                </el-form-item>
                <el-form-item class="form_item_val" label="上传文件">
                    <el-upload action :file-list="uploadFiles" accept=".xlsx,.jpg,.png,.pdf" :http-request="uploadRequest"
                        :limit="1" :on-success="uploadSuccess" :on-remove="uploadRemove" :before-upload="uploadBefore">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">
                            仅支持JPG、PNG格式图片，xlsx文档，pdf文件
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button :loading="uploadLoading" @click="doSave" type="text">确定</el-button>
                <el-button @click="hideUploadDialog" type="text">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import oss from '../../assets/js/ali-oss';
export default {
    data() {
        return {
            dealer: this.$common.getDealer(),
            user: this.$common.getUser(),
            tableRecords: [],

            total: 0,
            listQuery: {
                page: 1,
                limit: 10
            },

            uploadFiles: [],
            uploadFile: "",
            uploadFileSize: 0,
            uploadLoading: false,

            uploadForm: {
                name: ""
            },
            uploadFormRules: {
                name: [{
                    required: true,
                    message: "请输入文件名",
                    trigger: "blur"
                }],
            },

            uploadDialog: false
        };
    },
    filters: {},
    created() {
        this.getList();
    },
    methods: {
        reset() {
            this.listQuery.page = 1;
            this.getList();
        },
        getList() {
            var parent = this;
            this.$httpAuth
                .post("/v1/dealerFileRpc/list", {
                    dealerId: this.dealer.dealerId,
                    pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
                    pageCount: this.listQuery.limit
                })
                .then(function (response) {
                    parent.tableRecords = response.data.data;
                    parent.total = response.data.total;
                })
                .catch(() => { });
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },

        uploadBefore(file) {
            this.uploadFileSize = file.size;
        },

        uploadSuccess(res) {
            this.uploadFile = res;
        },
        uploadRequest(option) {
            oss.ossUploadFile(option)
        },
        uploadRemove() {
            this.uploadFile = "";
        },

        showUploadDialog() {
            this.uploadDialog = true;
        },

        hideUploadDialog() {
            this.uploadFiles = [];
            this.uploadFile = "";
            this.uploadForm.name = "";
            this.uploadDialog = false;
            this.uploadLoading = false;
        },

        doSave() {
            this.$refs["uploadForm"].validate(valid => {
                if (valid) {
                    if (this.uploadFile == "") {
                        this.$message({
                            message: "请选择导入文件",
                            type: "warning"
                        });
                        return;
                    }
                    console.log(this.uploadFile)
                    var parent = this;
                    this.$httpAuth
                        .post("/v1/dealerFileRpc/add", {
                            "dealerId": this.dealer.dealerId,
                            "fileName": this.uploadForm.name,
                            "fileUrl": this.uploadFile,
                            "fileSize": this.uploadFileSize,
                        })
                        .then(function () {
                            parent.hideUploadDialog();
                            parent.reset();
                        })
                        .catch(() => { });
                }
            });
        },
        toDelete(id) {
            this.$confirm('是否删除该文件?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var parent = this;
                this.$httpAuth
                    .post("/v1/dealerFileRpc/delete", {
                        "dealerId": this.dealer.dealerId,
                        "ids": id + '',
                    })
                    .then(function () {
                        parent.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        parent.reset()
                    })

            })
        },
    }
};
</script>
